import TomSelect from "tom-select";
import {TomInput} from "tom-select/dist/cjs/types/core";
import {api} from "../services/api";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    createPath: String,
    searchPath: String,
  };
  declare readonly createPathValue?: string;
  declare readonly hasCreatePathValue: boolean;
  declare readonly searchPathValue?: string;
  declare readonly hasSearchPathValue: boolean;
  select: TomSelect;

  connect() {
    this.select = new TomSelect(this.element as TomInput, {
      openOnFocus: true,
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      plugins: ['clear_button', 'remove_button'],
      create: !this.hasCreatePathValue ? false : (val, callback) => {
        if (!val?.length) return false;
        (async () => {
          const container = this.element.closest('.input.group.tom_select'),
              errorEl = container.querySelector('span.error'),
              res = await api.postJSON(this.createPathValue, { dealership_type: { name: val } });
          if (!res.ok) {
            const { error = 'Invalid input' } = await res.json;
            if (!!errorEl) {
              errorEl.textContent = error;
              errorEl.classList.remove('hidden');
            }
            this.select.clear();
            this.select.close();
            return;
          }
          errorEl.textContent = '';
          errorEl.classList.add('hidden');
          const data = await res.json;
          callback(data);
        })();
      }
    });
    if (this.hasSearchPathValue) this.initSearch(this.searchPathValue);
  }

  searchPathValueChanged = () => {
    if (!this.select) return;
    if (!this.hasSearchPathValue) {
      return;
    }
    this.select.clear();
    this.select.clearOptions();
    this.initSearch(this.searchPathValue);
  }

  initSearch = (searchPath: string) => {
    this.select.settings.load = async function(query, callback) {
      const self = this;
      self.clearOptions();
      const { data } = await api.axiosClient.get(searchPath, { params: { q: query }});
      callback(data ?? [], undefined);
    }
  }

  keydown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.select.createItem();
    }
  }
}
